import React from "react";

type BackArrowIconProps = {
  color?: string;
};

const BackArrowIcon: React.FC<BackArrowIconProps> = ({ color = "#0D0D0D" }) => {
  return (
    <svg
      width="25"
      height="21"
      viewBox="0 0 25 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0716 0.718152C12.6411 1.28767 12.6411 2.21103 12.0716 2.78055L5.81109 9.04102H22.707C23.5124 9.04102 24.1654 9.69393 24.1654 10.4994C24.1654 11.3048 23.5124 11.9577 22.707 11.9577H5.81109L12.0716 18.2182C12.6411 18.7877 12.6411 19.711 12.0716 20.2806C11.502 20.8501 10.5787 20.8501 10.0092 20.2806L1.25917 11.5305C0.985677 11.2571 0.832031 10.8861 0.832031 10.4994C0.832031 10.1126 0.985677 9.74164 1.25917 9.46815L10.0092 0.718152C10.5787 0.148637 11.502 0.148637 12.0716 0.718152Z"
        fill={color}
      />
    </svg>
  );
};

export default BackArrowIcon;
